const PrivacyPolicy = () => {
  return(
    <>
      <a href="https://www.iubenda.com/privacy-policy/51053804" className="nav-link p-0 slgo-light-text insalute-footer-link iubenda-nostyle no-brand iubenda-noiframe iubenda-embed iubenda-noiframe">Privacy e Cookie Policy</a>
      {(function (w,d) {var loader = function () {var s = d.createElement("script"), tag = d.getElementsByTagName("script")[0]; s.src="https://cdn.iubenda.com/iubenda.js"; tag.parentNode.insertBefore(s,tag);}; if(w.addEventListener){w.addEventListener("load", loader, false);}else if(w.attachEvent){w.attachEvent("onload", loader);}else{w.onload = loader;}})(window, document)}
    </>
  )
}

export default PrivacyPolicy;